import { InputFieldType } from "src/types/checkout";
import { ClipboardEvent, KeyboardEvent } from "react";

export const convertObjectToInputFields = (
  obj: Record<string, any>
): InputFieldType[] =>
  Object.keys(obj)?.map((key) => ({ inputCode: key, value: obj[key] }));

export const handleOnKeyPressNumberEvent = (
  event: KeyboardEvent<HTMLInputElement>
) => {
  ["e", "E", "+", "-"].includes(event.key) && event.preventDefault();
};

export const handleOnPasteNumberEvent = (
  event: ClipboardEvent<HTMLInputElement>
) => {
  event.preventDefault();

  document.execCommand(
    "insertText",
    false,
    event.clipboardData?.getData("text").replace(/\D/g, "")
  );
};
